import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicApprovalDto extends EpimsBaseEntityDto {

    Id : string;

    AssessmentId : string;
    
    DamageRefNo : string;
    
    SenderId : string;
    
    SenderName : string;
    
    SenderRemarks : string;
    
    ReceiverId : string;
    
    ReceiverName : string;
    
    ReceiverRemarks : string;
    
    SenderApprovalStatus : string;
    
    ReceiverApprovalStatus : string;
    
    ReceiverResponseDate : Date;
    
    SenderDateSent : Date;
    
    Descriptions : string;
    
    AssessmentDate : Date;
    
    ContractorId : string;
    
    ContractorName : string;
    
    Location : string;
    
    LineTypeId : string;
    
    LineTypeName : string;
    
    LineNumber : string;
    
    SwathId : string;
    
    SwathNo : string;
    
    ProgrammeId : string;
    
    ProgrammeName : string;
    
    AccessorName : string;
    
    AccessorId : string;
    
    OMLId : string;
    
    OMLName : string;
    
    TotalAmount : number;
    CouponNo : string;
    IsFlagged: boolean;
    IsFlaggedDate: Date;
    LastFlaggedById: string;
    LastFlaggedByName: string;
    LastFlaggedStatus: string;
    AllFlags: string;
    ApprovalTrackingNo: string;

    
    CheckerIsFlagged: boolean;
    
    CheckerIsFlaggedDate: Date;
    
    CheckerLastFlaggedById: string;
    
    CheckerLastFlaggedByName: string;
    
    CheckerLastFlaggedStatus: string;
    
    CheckersAllFlags: string;
    
    ApproveById: string;

    
    ApproveByName: string;
    
    ApproveType: string;
    
    DelegateIsFlagged: boolean;
    
    DelegateRemarks: string;
    
    DelegateApproveStatus: string;
    
    DelegateReviewDate: Date;
    
    DelegateId: string;
    
    DelegateName: string;
    
    CheckersRemarks: string;
    SubscriptionUserId: string;  
    Version: number;
    LevelPriority: number;
 
    LastFlaggedByRemarks: string; 
    
    SenderEmail: string; 
  
    ReceiverEmail: string; 
  
    CheckerEmail: string; 
    MailSent: string;
    IsReSubmitted: boolean;

}


